import { classNames } from 'primereact/utils';
import { string } from 'prop-types';
import React from 'react';
import { useLocation } from 'react-router-dom';
import first from '../../../../assets/images/card1.png';
import second from '../../../../assets/images/card2.png';
import third from '../../../../assets/images/card3.png';
import fourth from '../../../../assets/images/card4.png';
import fifth from '../../../../assets/images/card5.png';
import six from '../../../../assets/images/card6.png';
import { FormattedMessage, useIntl } from '../../../../util/reactIntl';
import { createResourceLocatorString } from '../../../../util/routes';
import { DealType } from '../../../../util/types';
import css from './DealTypes.module.css';

const DealTypes = (props) => {
  const {
    intl: intlProp,
    history,
    routeConfiguration,
    showSignup = true,
    showViewAll = true,
    compactMode = false,
    onDealTypeSelect = null,
  } = props;
  const intl = intlProp || useIntl();
  const location = useLocation();
  const arabicLanguage = typeof window !== 'undefined' && localStorage.getItem("language") === "Arabic";
  const normalizedPath = (location?.pathname || '').replace(/\/+$/, '');
  const isDealTypesPage = normalizedPath === '/deal-types';
  const isDealsSearchPage = normalizedPath === '/s/deals';
  const selectedDealType =
    onDealTypeSelect == null
      ? new URLSearchParams(location?.search || '').get('publicData.categoryLevel2') || ''
      : '';

  const dealsDetail = [
    {
      title: intl.formatMessage({ id: "DealTypes.percentageDiscount" }),
      description: intl.formatMessage({ id: "category.description.percentage-discount" }),
      image: first,
      key: DealType?.PERCENTAGE_DISCOUNT
    },
    {
      title: intl.formatMessage({ id: "DealTypes.amountDiscount" }),
      description: intl.formatMessage({ id: "category.description.amount-discount" }),
      image: second,
      key: DealType?.AMOUNT_DISCOUNT
    },
  ]

  // Commented out - Not currently supported
  // const dealsDetail = [
  //   {
  //     title: intl.formatMessage({ id: "DealTypes.percentageDiscount" }),
  //     image: first,
  //     key: DealType?.PERCENTAGE_DISCOUNT
  //   },
  //   {
  //     title: intl.formatMessage({ id: "DealTypes.bulkDiscount" }),
  //     image: third,
  //     key: DealType?.BULK_DISCOUNT
  //   },
  //   {
  //     title: intl.formatMessage({ id: "DealTypes.buyOneGetOneHalfOff" }, { breakLine: <br /> }),
  //     image: fifth,
  //     key: DealType?.BUY_ONE_GET_ONE_HALF_OFF
  //   },
  //   {
  //     title: intl.formatMessage({ id: "DealTypes.amountDiscount" }),
  //     image: second,
  //     key: DealType?.AMOUNT_DISCOUNT
  //   },
  //   {
  //     title: intl.formatMessage({ id: "DealTypes.buyOneGetOneFree" }, { breakLine: <br /> }),
  //     image: fourth,
  //     key: DealType?.BUY_ONE_GET_ONE_FREE
  //   },
  //   {
  //     title: intl.formatMessage({ id: "DealTypes.serviceBundles" }),
  //     image: six,
  //     key: DealType?.SERVICE_BUNDLES
  //   },
  // ]



  return (
    <div
      className={classNames(
        css.dealTypesWrapper,
        compactMode && css.compactMode,
        arabicLanguage && css.arabicRowReverse
      )}
    >
      {!isDealTypesPage ? (
        <div className={classNames(css.dealTopRow)}>
          <div className={classNames(css.dealHeading)}>
            <FormattedMessage id="CustomerHomePage.topDealTypes" />
          </div>
          {showViewAll ? (
            <div
              className={css.viewAllLink}
              onClick={() => {
                history.push(
                  createResourceLocatorString(
                    'AlgoliaSearchPage',
                    routeConfiguration,
                    { listingType: "deals" },
                    {}
                  )
                );
              }}
            >
              <FormattedMessage id="CustomerHomePage.viewAll" />
            </div>
          ) : null}
        </div>
      ) : null}

      {!isDealTypesPage ? (
        <div className={css.gridContainer}>
          {dealsDetail.map((deal, dealIndex) => (
            <div
              key={dealIndex}
              className={classNames(css.card, selectedDealType === deal.key && css.cardSelected)}
              onClick={() => {
                if (onDealTypeSelect) {
                  onDealTypeSelect(deal.key);
                } else {
                  history.push(
                    createResourceLocatorString(
                      'AlgoliaSearchPage',
                      routeConfiguration,
                      { listingType: "deals" },
                      { "publicData.categoryLevel2": deal.key }
                    )
                  );
                }
              }}
            >
              {isDealsSearchPage && selectedDealType === deal.key ? (
                <span className={css.selectedBadge}>
                  <FormattedMessage id="DealTypes.selected" />
                </span>
              ) : null}
              <div className={css.icon}><img src={deal.image} alt="" /></div>
              <h3>{deal.title}</h3>
              <p className={css.description}>{deal.description}</p>
              <span className={css.link}> {intl.formatMessage({ id: "DealTypes.shopNow" })}</span>
            </div>
          ))}
        </div>
      ) : null}
      {showSignup ? (
        <div className={css.signUp}>{intl.formatMessage({ id: "DealTypes.doYouOwn" })} <span>
          {intl.formatMessage({ id: "DealTypes.now" })}
        </span></div>
      ) : null}
    </div>
  )
};

DealTypes.defaultProps = {
  className: null,
  rootClassName: null,
  showSignup: true,
  showViewAll: true,
  compactMode: false,
};

DealTypes.propTypes = {
  className: string,
  rootClassName: string,
};

export default DealTypes;
